import request from "@/api";

export function listActivity(data) {
    return request({
        url: '/api/activity/getActivityList',
        method: 'get',
        params: data
    })
}
export function saveActivity(data) {
    return request({
        url: '/api/activity/saveActivity',
        method: 'post',
        data: data
    })
}

export function getActivityInfo(data) {
    return request({
        url: '/api/activity/getActivityInfo',
        method: 'get',
        params: data
    })
}

export function deleteActivity(data) {
    return request({
        url: '/api/activity/deleteActivity',
        method: 'post',
        data: data
    })
}